import {
  Button,
  Disclaimer,
  Div,
  ErrorToast,
  H3,
  H5,
  Img,
  Modal,
  P,
  PropsModal,
  Radio,
  assignVDriveDriver,
  displayCentsInDollars,
  formatMinutesToHoursMinutes,
  lightTheme,
  renderFleetImage,
  useOrders,
  reportError,
} from '@vgrubs/components';
import { AssignVDriveDriverRequestData } from 'components/src/types/api/order.types';
import { Order, VDriveOfferEntity } from 'components/src/types/order.types';
import { DateTime } from 'luxon';
import { Dispatch, SetStateAction, useState } from 'react';

export const VDriveAssignDriver = ({
  order,
  setOrder,
  modalIsOpen,
  closeModal,
  noDriverModal,
  setNoDriverModal,
  setLoading,
}: PropsModal & {
  order: Order;
  setOrder: Dispatch<SetStateAction<Order | null>>;
  modalIsOpen: VDriveOfferEntity[] | null;
  setNoDriverModal: Dispatch<SetStateAction<boolean>>;
  noDriverModal: boolean;
}) => {
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);
  const [selectedDriver, setSelectedDriver] =
    useState<VDriveOfferEntity | null>(null);

  const { assignVDriveProviderOnList } = useOrders((state) => state);

  async function handleAssignDriver() {
    if (!selectedDriver) return ErrorToast('Select driver first');

    const body: AssignVDriveDriverRequestData = {
      price: selectedDriver.price,
      provider: selectedDriver.provider,
    };

    try {
      setLoading?.(true);
      const { data } = await assignVDriveDriver(order.id, body);

      setOrder(data.data);
      assignVDriveProviderOnList(order.id, selectedDriver.provider);
      setLoading?.(false);
      closeModal?.();
      setSuccessModalIsOpen(true);
    } catch (error) {
      reportError(error);
      setLoading?.(false);
    }
  }

  const handleSelectDriver = (newItem: VDriveOfferEntity) => {
    setSelectedDriver(newItem);
  };

  function isDriverSelected(item: VDriveOfferEntity) {
    return selectedDriver?.id === item.id;
  }

  const isVGrubsBrand =
    !order.brand.isLocation && order.brand.type === 'vGrubs';

  // const amount = () => {
  //   if (isVGrubsBrand) {
  //     return selectedDriver.price;
  //   }
  //   return selectedDriver.price + order.charges.tips;
  // };

  return (
    <>
      <Modal
        isOpen={!!modalIsOpen}
        closeModal={closeModal}
        logo={false}
        vDriveLogo={true}
        zIndex={110}
        footer={
          <>
            <Button
              $m="32px 0 12px 0"
              $w="100%"
              $selected
              onClick={handleAssignDriver}
            >
              Assign Driver{' '}
              {/* {selectedDriver && `(${displayCentsInDollars(amount())})`} */}
            </Button>
            <Button $w="100%" $selected $gray onClick={closeModal}>
              Cancel
            </Button>
          </>
        }
      >
        <H3 $mb="24px">Assign Driver</H3>
        {modalIsOpen &&
          modalIsOpen?.map((l, i) => (
            <Div
              key={i}
              $box
              $p="14px 24px"
              $mb="8"
              $flex
              $alignCenter
              $between
              onClick={() => handleSelectDriver(l)}
              $gap="16px"
              $pointer
            >
              <Div $flex $alignCenter $gap="20px">
                <Img alt="" src={renderFleetImage(l.provider)} $width="60px" />
                <div>
                  {l.deliveryMinutes !== -1 && (
                    <H5
                      $left
                      $bold
                      $mb="0"
                      $color={isDriverSelected(l) && lightTheme.primary}
                    >
                      Drop Off Time:{' '}
                      {formatMinutesToHoursMinutes(l.deliveryMinutes)}
                    </H5>
                  )}
                  <P $left $mb="0">
                    Delivery Fee + Tip:{' '}
                    {displayCentsInDollars(l.price + (l.tip || 0))}
                  </P>
                  <P $left $mb="0">
                    Distance: {l.distance} miles
                  </P>
                </div>
              </Div>

              <Radio checked={isDriverSelected(l)} />
            </Div>
          ))}

        {!isVGrubsBrand && (
          <Disclaimer $mt="24">
            The price includes the delivery fee and tip combined.
          </Disclaimer>
        )}

        {/* {dataOrders.length < 1 && (
          <Div $flex $center $column>
            <Img src={menuItems} alt="no menu items" $width="300px" />
            <H3 $color={lightTheme.primary} $mb="20">
              No Orders!
            </H3>
            <P $bold>You currently don’t have {status} orders.</P>
          </Div>
        )} */}
      </Modal>

      <Modal
        isOpen={successModalIsOpen}
        closeModal={() => setSuccessModalIsOpen(false)}
        logo={false}
        vDriveLogo={true}
      >
        <H3 $mb="12">Driver Assigned</H3>

        <P $mb="0">
          {order.timestamps?.scheduledFor !== null
            ? `This driver will be assigned for scheduled order tomorrow 
            ${DateTime.fromISO(order.timestamps?.scheduledFor || '')
              .setZone(order.timeZone)
              .toFormat('hh:mm a')}`
            : 'Driver assigned successfully'}
        </P>
        <Button
          $m="32px 0 12px 0"
          $w="100%"
          $selected
          onClick={() => setSuccessModalIsOpen(false)}
        >
          Okay
        </Button>
      </Modal>

      <Modal
        isOpen={noDriverModal}
        closeModal={() => setNoDriverModal(false)}
        logo={false}
        vDriveLogo={true}
        zIndex={110}
      >
        <H3 $mb="12">No Driver</H3>

        <P $mb="0">There are no available drivers at the moment.</P>
        <Button
          $m="32px 0 12px 0"
          $w="100%"
          $selected
          onClick={() => setNoDriverModal(false)}
        >
          Okay
        </Button>
      </Modal>
    </>
  );
};
